import { isEmpty } from 'ramda';

const buildJourneyDigestShape = (segment) =>
  !isEmpty(segment)
    ? segment.map((seg) => ({
        bookingItems: seg.bookingItems,
        legs: { products: seg.products, serviceType: seg.serviceType },
        origin: seg.origin,
        destination: seg.destination,
        date: seg.timing.date,
        arrivalTime: seg.timing.arrives,
        departureTime: seg.timing.departs,
        classOfService: seg.classOfService,
        productFamily: seg.productFamily,
        addOnLeg: seg?.addOnLeg?.activeBookingItems
      }))
    : [];

export default buildJourneyDigestShape;
